import { render, staticRenderFns } from "./base_util.vue?vue&type=template&id=36cc62c2&scoped=true&"
import script from "./base_util.vue?vue&type=script&lang=js&"
export * from "./base_util.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cc62c2",
  null
  
)

export default component.exports